import { createAsyncThunk } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { processesProgressService } from '../../services/processesProgressService'
import { GET_PROCESS_PROGRESS_DATA } from '../config'
import { IRequestActionParams } from '../models'
import { selectProcessesProgressLoadingStatus } from '../selectors/selectProcessesProgressData'

import { handleApiResponse } from './helpers/handleApiResponse'

class ProcessesProgressApi {
  public getProcessesProgress = createAsyncThunk(
    GET_PROCESS_PROGRESS_DATA,
    async ({ requestId }: IRequestActionParams, _thunkAPI) => {
      const response = await processesProgressService.fetchRequestProcessesProgress(requestId)
      return handleApiResponse(response)
    },
    {
      condition({ requestId }, { getState }) {
        if (!requestId) {
          return false
        }

        const state = getState() as any
        const status = selectProcessesProgressLoadingStatus(state)
        if (status === RequestStatus.PENDING) {
          return false
        }

        return
      },
    }
  )
}

export const processesProgressApi = new ProcessesProgressApi()
